module.exports = __webpack_public_path__ + "static/media/milling-machine.1d821460.svg";